import type { Lang } from "@/src/context/LanguageContext"

const translations = {
  uk: {
    navWhyUs: "Чому ми",
    navServices: "Наші послуги",
    navContacts: "Контакти",
    navCta: "Хочу ремонт",
    navWhyUsMobile: "Чому ми?",
    navServicesMobile: "Наші послуги",

    heroIntro: "Обравши співпрацю з нами, ви зможете",
    heroIntroHighlight: "вирішити безліч питань",
    heroIntroSuffix: ", які можуть виникнути під час ремонту, головні з яких:",
    heroBtnPrice: "Вартість",
    heroBtnContacts: "Контакти",

    pricingHeading: "Що входить у вартість:",
    pricingCta: "Залишити заявку",
    pricingPhotoAlt: "фото",
    squareMeter: "м²",

    reviewsLabel: "Відгуки",
    reviewsTitle: "Що кажуть наші клієнти",
    reviewsCtaWrite: "Залишити відгук",
    reviewsCtaAll: "Всі відгуки на Google",
    reviewsCountLabel: "підтверджених відгуків",
    reviewsRatingLabel: "середній рейтинг",
    reviewsSeeOnGoogle: "Переглянути на Google",

    footerSocial: "Соціальні мережі",
    footerMenu: "Меню",
    footerAbout: "Про нас",
    footerPrice: "Вартість",
    footerConsult: "Отримати консультацію",
    footerContacts: "Контакти",
    footerContactsHeading: "Контакти",
    footerCopyright: "Всі права захищені.",
    footerPrivacy: "Політика конфіденційності",

    cookieText: "Ми використовуємо cookies для покращення роботи сайту та аналітики. Детальніше — в нашій",
    cookiePrivacyLink: "Політиці конфіденційності",
    cookieAccept: "Прийняти",
    cookieDecline: "Відхилити",

    messengerCall: "Зателефонувати",
    messengerClose: "Закрити меню месенджерів",
    messengerOpen: "Написати нам",

    contactFormTitle: "Залишити заявку",

    contactInfoHeading: "Контактна інформація",
    contactPhone: "Телефон",
    contactEmail: "Email",
    contactAddress: "Адреса",
    contactPhoneAria: "Зателефонувати за номером +38 063 664 41 32",
    contactEmailAria: "Написати листа на obelisk79011@gmail.com",
    contactAddressAria: "Відкрити адресу у Google Maps",
    contactHoursHeading: "Режим роботи",
    contactHoursMon: "Понеділок - Субота:",
    contactHoursSun: "Неділя:",
    contactHoursSunVal: "вихідний",
    contactFreeHeading: "Безкоштовна консультація",
    contactFreeDesc: "Наш спеціаліст безкоштовно приїде на об'єкт, проведе заміри, розрахує вартість робіт та надасть професійні рекомендації.",
    contactFreeTag: "Виїзд протягом 24 годин",

    formLabel1: "1. ПІБ або назва організації:",
    formPlaceholder1: "Введіть ваше ПІБ або назву організації",
    formError1Required: "ПІБ або назва організації є обов'язковим полем",
    formError1Short: "ПІБ повинно містити принаймні 2 символи",
    formLabel2: "2. Контактний номер телефону:",
    formPhonePlaceholder: "+380…",
    formPhoneDefault: "+380",
    formPhoneRegex: "^\\+380\\d{9}$",
    formPhoneErrorRequired: "Номер телефону є обов'язковим полем",
    formPhoneErrorFormat: "Введіть коректний номер телефону у форматі +380XXXXXXXXX",
    formLabel3: "3. Тип приміщення:",
    formError3: "Оберіть тип приміщення",
    formOtherPremisePlaceholder: "Вкажіть тип приміщення",
    formOtherPremiseError: "Вкажіть тип приміщення",
    formLabel4: "4. Характеристика будівлі:",
    formError4: "Оберіть характеристику будівлі",
    formLabel5: "5. Чи потрібен демонтаж у приміщенні?",
    formError5: "Вкажіть чи потрібен демонтаж",
    formDemolitionPlaceholder: "Вкажіть, що саме потрібно демонтувати (стіни, підлога, сантехніка, електрика тощо)...",
    formDemolitionError: "Вкажіть що саме потрібно демонтувати",
    formLabel6: "6. Чи є у вас розроблений дизайн-проєкт?",
    formError6: "Вкажіть чи є дизайн-проєкт",
    formLabel7: "7. Що для вас важливо:",
    formLabel7Sub: "Оберіть максимум 2 варіанти",
    formLabel8: "8. Бажані терміни початку та завершення ремонту:",
    formDateStart: "Початок:",
    formDateEnd: "Завершення:",
    formLabel9: "9. Додатковий коментар",
    formCommentPlaceholder: "Розкажіть про ваші побажання, особливості проекту, бюджет або інші важливі деталі...",
    formSubmit: "Відправити заявку",
    formSubmitting: "Відправляємо...",
    formSubmittingAria: "Форма відправляється, будь ласка, зачекайте",
    formPrivacyText: "Натискаючи кнопку, ви погоджуєтесь з нашою",
    formPrivacyLink: "Політикою конфіденційності",
    formSuccessTitle: "Успіх!",
    formErrorTitle: "Помилка!",
    formUnexpectedError: "Виникла непередбачена помилка. Спробуйте ще раз або зв'яжіться за телефоном.",
    formAriaLabel: "Форма попереднього замовлення ремонту",
  },

  fr: {
    navWhyUs: "Pourquoi nous",
    navServices: "Nos services",
    navContacts: "Contact",
    navCta: "Je veux une rénovation",
    navWhyUsMobile: "Pourquoi nous ?",
    navServicesMobile: "Nos services",

    heroIntro: "En choisissant de collaborer avec nous, vous pourrez",
    heroIntroHighlight: "résoudre de nombreuses questions",
    heroIntroSuffix: " qui peuvent surgir lors de la rénovation, dont les principales :",
    heroBtnPrice: "Tarifs",
    heroBtnContacts: "Contact",

    pricingHeading: "Ce qui est inclus dans le prix :",
    pricingCta: "Laisser une demande",
    pricingPhotoAlt: "photo",
    squareMeter: "m²",

    reviewsLabel: "Avis",
    reviewsTitle: "Ce que disent nos clients",
    reviewsCtaWrite: "Laisser un avis",
    reviewsCtaAll: "Tous les avis sur Google",
    reviewsCountLabel: "avis vérifiés",
    reviewsRatingLabel: "note moyenne",
    reviewsSeeOnGoogle: "Voir sur Google",

    footerSocial: "Réseaux sociaux",
    footerMenu: "Menu",
    footerAbout: "À propos",
    footerPrice: "Tarifs",
    footerConsult: "Obtenir une consultation",
    footerContacts: "Contact",
    footerContactsHeading: "Contacts",
    footerCopyright: "Tous droits réservés.",
    footerPrivacy: "Politique de confidentialité",

    cookieText: "Nous utilisons des cookies pour améliorer le fonctionnement du site et l'analyse. En savoir plus dans notre",
    cookiePrivacyLink: "Politique de confidentialité",
    cookieAccept: "Accepter",
    cookieDecline: "Refuser",

    messengerCall: "Appeler",
    messengerClose: "Fermer le menu messagerie",
    messengerOpen: "Nous écrire",

    contactFormTitle: "Laisser une demande",

    contactInfoHeading: "Informations de contact",
    contactPhone: "Téléphone",
    contactEmail: "E-mail",
    contactAddress: "Adresse",
    contactPhoneAria: "Appeler le +38 063 664 41 32",
    contactEmailAria: "Écrire à obelisk79011@gmail.com",
    contactAddressAria: "Ouvrir l'adresse dans Google Maps",
    contactHoursHeading: "Horaires de travail",
    contactHoursMon: "Lundi — Samedi :",
    contactHoursSun: "Dimanche :",
    contactHoursSunVal: "fermé",
    contactFreeHeading: "Consultation gratuite",
    contactFreeDesc: "Notre spécialiste se rendra gratuitement sur le chantier, effectuera les mesures, calculera le coût des travaux et fournira des recommandations professionnelles.",
    contactFreeTag: "Déplacement dans les 24 heures",

    formLabel1: "1. Nom complet ou raison sociale :",
    formPlaceholder1: "Entrez votre nom complet ou raison sociale",
    formError1Required: "Le nom complet ou la raison sociale est obligatoire",
    formError1Short: "Le nom doit contenir au moins 2 caractères",
    formLabel2: "2. Numéro de téléphone :",
    formPhonePlaceholder: "+33…",
    formPhoneDefault: "+33",
    formPhoneRegex: "^\\+\\d{7,15}$",
    formPhoneErrorRequired: "Le numéro de téléphone est obligatoire",
    formPhoneErrorFormat: "Entrez un numéro de téléphone valide au format international (+33XXXXXXXXX)",
    formLabel3: "3. Type de local :",
    formError3: "Choisissez le type de local",
    formOtherPremisePlaceholder: "Précisez le type de local",
    formOtherPremiseError: "Précisez le type de local",
    formLabel4: "4. Caractéristique du bâtiment :",
    formError4: "Choisissez la caractéristique du bâtiment",
    formLabel5: "5. Une démolition est-elle nécessaire dans le local ?",
    formError5: "Indiquez si une démolition est nécessaire",
    formDemolitionPlaceholder: "Précisez ce qui doit être démoli (murs, sol, plomberie, électricité, etc.)...",
    formDemolitionError: "Précisez ce qui doit être démoli",
    formLabel6: "6. Avez-vous un projet de design élaboré ?",
    formError6: "Indiquez si vous avez un projet de design",
    formLabel7: "7. Qu'est-ce qui est important pour vous :",
    formLabel7Sub: "Choisissez au maximum 2 options",
    formLabel8: "8. Délais souhaités pour le début et la fin des travaux :",
    formDateStart: "Début :",
    formDateEnd: "Fin :",
    formLabel9: "9. Commentaire supplémentaire",
    formCommentPlaceholder: "Décrivez vos souhaits, les particularités du projet, le budget ou d'autres détails importants...",
    formSubmit: "Envoyer la demande",
    formSubmitting: "Envoi en cours...",
    formSubmittingAria: "Le formulaire est en cours d'envoi, veuillez patienter",
    formPrivacyText: "En cliquant sur le bouton, vous acceptez notre",
    formPrivacyLink: "Politique de confidentialité",
    formSuccessTitle: "Succès !",
    formErrorTitle: "Erreur !",
    formUnexpectedError: "Une erreur inattendue s'est produite. Veuillez réessayer ou nous contacter par téléphone.",
    formAriaLabel: "Formulaire de demande de rénovation",
  },
} as const

export type UIKey = keyof typeof translations.uk

export function useUI(lang: Lang): (key: UIKey) => string {
  return (key: UIKey) => translations[lang][key] as string
}
